import { action, makeObservable, observable } from 'mobx';
import { winBarStore } from './winBarStore';
import { amountContainerInfo } from '../core/constants/amountContainerInfo';
import {applicationStore} from "./applicationStore";

class FreeBetStore {
  freeBetList = [];

  isFreeBetEnd = false;

  currentFreeBet = null;

  isShowFreeBetPopup = false;

  constructor() {
    makeObservable(this, {
      freeBetList: observable,
      isFreeBetEnd: observable,
      currentFreeBet: observable,
      isShowFreeBetPopup: observable,
      setFreeBetList: action.bound,
      showFreeBetInfo: action.bound,
      setIsFreeBetEnd: action.bound,
      updateFreeBetInfo: action.bound,
      setCurrentFreeBet: action.bound,
      setIsShowFreeBetPopup: action.bound,
    });
  }

  showFreeBetInfo(userFreeBets) {
    if (userFreeBets[0]) {
      this.setIsFreeBetEnd(false);
      this.setCurrentFreeBet(userFreeBets[0]);
      this.setFreeBetList(userFreeBets);
      this.setIsShowFreeBetPopup(true);
    } else {
      if (winBarStore.totalWinAmount || winBarStore.lastWinAmount) {
        winBarStore.updateShowAmountContainerInfo(
          winBarStore.totalWinAmount
            ? amountContainerInfo.totalWinContainer
            : amountContainerInfo.lastWinContainer,
          true
        );
      } else {
        winBarStore.hideAmountContainer();
      }

      this.setCurrentFreeBet(null);
    }
  }

  updateFreeBetInfo() {
    this.setIsShowFreeBetPopup(false);
    this.setCurrentFreeBet(this.freeBetList[0]);
    const updatedFreeBetList = [...this.freeBetList].slice(1);
    this.setFreeBetList(updatedFreeBetList);
  }

  freeBetEnd() {
    this.setIsFreeBetEnd(true);
    this.setIsShowFreeBetPopup(true);
  }

  setIsShowFreeBetPopup(bool) {
    this.isShowFreeBetPopup = bool;
    applicationStore.setIsShowBlackLayer(bool);
  }

  setIsFreeBetEnd(bool) {
    this.isFreeBetEnd = bool;
  }

  setFreeBetList(list) {
    this.freeBetList = list;
  }

  setCurrentFreeBet(currentFreeBet) {
    this.currentFreeBet = currentFreeBet;
  }
}

export const freeBetStore = new FreeBetStore();
